// Delivery charge of an order in taka.
// New orders (2026-10-31) carry their own `deliveryAmount` (the charge when the
// order was placed); older orders only have the zone ("dhaka" / "outside"),
// so the store's current charge is used for them.
// `other` = what the screen used before for an order with no zone.
export const orderDeliveryAmount = (order, dhaka, outside, other = 0) => {
    const own = order?.deliveryAmount;
    if (own !== undefined && own !== null && own !== '' && Number.isFinite(Number(own))) return Number(own);
    if (order?.deliveryCharge === 'dhaka') return parseInt(dhaka, 10) || 0;
    if (order?.deliveryCharge === 'outside') return parseInt(outside, 10) || 0;
    return parseInt(other, 10) || 0;
};
